/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import fontOptions from '../utils/controllersUtils/options';

import ControllersGroup from './ControllersGroup';
import {
  InputLineController,
  ToggleSwitchController,
  SelectController,
  ButtonLineController,
  ChoiceBoxController,
  IconChoiceBoxController,
} from './Base';
import {
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
} from '../../icons';

const alignOpts = [
  {
    value: 'left',
    icon: <AlignLeft />,
    label: 'Esquerda',
    id: 'align-left',
  },
  {
    value: 'center',
    icon: <AlignCenter />,
    label: 'Centro',
    id: 'align-center',
  },
  {
    value: 'right',
    icon: <AlignRight />,
    label: 'Direita',
    id: 'align-right',
  },
  {
    value: 'justify',
    icon: <AlignJustify />,
    label: 'Justificado',
    id: 'align-justify',
  },
];

const MainTitle = ({
  config = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  isGlobalThemeActive = false,
  isGlobalFontActive = false,

}) => (
  <>
    <ControllersGroup title="Título" id="title" extend={extend} setExtend={setExtend}>
      <InputLineController
        label="Título do KPI"
        handle={handle}
        configValue={config?.TitleControl}
        kWord="TitleControl"
        fullWidth
      />
      <ToggleSwitchController
        label="Mostrar Título"
        handle={handle}
        kWord="ShowTitleControl"
        configValue={config?.ShowTitleControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <SelectController
        label="Fonte"
        handle={handle}
        kWord="TitleFontFamily"
        options={fontOptions}
        configValue={config?.StyleTitleControl?.fontFamily}
        text={config?.UseGlobalFont !== false && isGlobalFontActive ? 'Utilizando fonte global' : ''}
        disabled={!config?.ShowTitleControl?.checked || (
          config?.UseGlobalFont !== false && isGlobalFontActive
        )}
      />
      <InputLineController
        label="Tamanho"
        handle={handle}
        kWord="TitleFontSize"
        configValue={config?.StyleTitleControl?.fontSize}
        min={1}
        max={80}
        step={1}
        precision={0}
        isNumber
        disabled={!config?.ShowTitleControl?.checked}
      />
      <ButtonLineController
        handle={handle}
        boldKWord="TitleBold"
        boldVal={config?.StyleTitleControl?.bold}
        italicKWord="TitleItalic"
        italicVal={config?.StyleTitleControl?.italic}
        underlineKWord="TitleUnderline"
        underlineVal={config?.StyleTitleControl?.underline}
        fontColorKWord="TitleFontColor"
        fontColorVal={config?.StyleTitleControl?.color}
        fontColorText="Utilizando tema global"
        fontColorDisabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
        disabled={!config?.ShowTitleControl?.checked}
        fullWidth
      />
      <IconChoiceBoxController
        label="Alinhamento"
        handle={handle}
        kWord="TitleAlign"
        options={alignOpts}
        configValue={config?.StyleTitleControl?.align || 'center'}
        fullWidth
        toggleTooltip
        grid={[4, 1]}
      />
    </ControllersGroup>
  </>
);

MainTitle.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
};

export default MainTitle;
